import { Link } from "react-router-dom"
import { useNavigate } from "../../hook/useNavigate";


const JoinBetaButton = ({ onClick }) => {
  const { navNewTab } = useNavigate();

  return (
    <Link onClick={() => {
      if (onClick) {
        onClick()
      }
      navNewTab("https://play.ztpoker.com")
    }
    } className="sign-btn">
      Join Beta
    </Link>
  )
}

export default JoinBetaButton